import styled from "styled-components";

import Colors from '../../../../themes/Colors';
const AudienceResumenHolder = styled.div`
  .audience-graph {
    padding: 5px;
  }

  .audience-graph h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .audience-graph h4 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .audience-graph-container {
    margin: 6px 0;
    height: 280px;
    max-height: 280px;
  }

  .card-container {
    min-height: 100px;
    padding: 15px;
    text-align: center;
    background: ${Colors.snow};
    border: 1px solid ${Colors.border};
    border-radius: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .data-title {
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 8px;
    color: ${Colors.textStrong};
  }

  .audience-note {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: ${Colors.textMuted};
    font-size: 13px;
    margin: 8px 0 16px;
    text-align: center;
  }
`;

export default AudienceResumenHolder;
